<template>
  <!-- 试卷管理 列表页 -->
    <div class="board">
        <div v-hasPermi="['arrangement:examinee:list']">
            <div class="title">
                <span class="name">{{ paperTextConfig.title }}</span>
            </div>
            <el-form :inline="true" :model="form" ref="form">
                <el-form-item>
                    <el-button type="primary" @click="chooseDialogVisible = true" :disabled="examStatus ==3">{{ paperTextConfig.button.choose }}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="danger" @click="remove()" :disabled="examStatus ==3">{{ paperTextConfig.button.remove }}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="form.name" clearable :placeholder="paperTextConfig.form.nameTip"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search()">{{ paperTextConfig.form.button.search }}</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="paperList" v-loading="loading" element-loading-text="加载中"
                      element-loading-spinner="el-icon-loading" ref="multipleTable" stripe size="medium"
                       @selection-change="handleSelectionChange" height="500px">
                <el-table-column type="selection" width="48" fixed="left" align="center"></el-table-column>
                <el-table-column prop="name" :label="tableTextConfig.name"
                                 :min-width="flexColumnWidth('name',4,tableData)" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="question_num" :label="tableTextConfig.questionNum" min-width="50">
                    <template slot-scope="scope">
                        <el-tooltip placement="right">
                            <div slot="content" style="line-height:22px"><span
                                    v-for="(e,j) in scope.row.metas.question_overview"
                                    :key="j">{{ e.label }}：{{ e.num }}<br/></span></div>
                            <el-button type="text">{{ scope.row.question_num }}</el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="total_score" :label="tableTextConfig.totalScore"
                                 min-width="50"></el-table-column>
                <el-table-column :label="tableTextConfig.updatedAt" min-width="150px">
                    <template slot-scope="scope">
                        <p>{{ scope.row.updated_by_username }}</p>
                        <p class="updateDate">{{ scope.row.updated_at | formatTime }}</p>
                    </template>
                </el-table-column>
                <el-table-column :label="tableTextConfig.operate" width="100px">
                    <template slot-scope="scope">
                        <el-button  type="danger" size="mini" @click="deletePaper(scope.row)" >
                            {{ buttonTextConfig.delete }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <choose-paper-dialog :show.sync="chooseDialogVisible" :choosePapers="tableData" :oldTableData="oldTableData" :examStatus="examStatus"  :limitNum="limitNum" :examCategory="examCategory" @close="close" @choose="choose"></choose-paper-dialog>
            <div style="margin-top: 10px">
                <el-button type="primary" @click="check" v-if="examStatus !=3">{{buttonTextConfig.saveAndCheck}}</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import {judgePermissions} from '@/utils/common.js'
import choosePaperDialog from '../../dialog/choosePaperDialog.vue'
import {getExamPapers, getExamPaperLimitNum} from "@/api/arrangement";

export default {
    components: {
        choosePaperDialog
    },
    props: ['examId', 'examCategory', 'examStatus'],
    data() {
        return {
            height: 250,
            loading: false,
            form: {
                name: '',
                status: null,
            },
            tableData: [],
            oldTableData: [],
            chooseDialogVisible: false,
            selectRow: [],
            limitNum: 10,
        }
    },

    computed: {
        paperTextConfig() {
            return this.$store.state.global.textConfig.backend.arrangement.examEdit.paper
        },
        tableTextConfig() {
            return this.paperTextConfig.table
        },
        buttonTextConfig() {
            return this.tableTextConfig.button
        },
        paperList() {
            let list = this.tableData;
            let result = list.filter(item => item.name.indexOf(this.form.name) > -1);
            return result;
        },
    },
    methods: {
        judgePermissions,
        search() {
        },
        remove(){
            let flag = false;
            if (this.examStatus >= 2) {
                for (let j = 0; j < this.selectRow.length; j++) {
                    let data = this.oldTableData.filter((item)=> item.id == this.selectRow[j].id)
                    if (data.length > 0) {
                        flag = true;
                        break;

                    }
                }
            }
            if (flag) {
                this.$message({
                    type: 'warning',
                    message: this.paperTextConfig.button.notRemoveTip
                });
            } else {
                for (let j = 0; j < this.selectRow.length; j++) {
                    let index = this.tableData.indexOf(this.selectRow[j]);
                    this.tableData.splice(index,1)
                }
            }

        },
        deletePaper(row){
            if (this.examStatus >= 2) {
                let data = this.oldTableData.filter((item)=> item.id == row.id)
                if (data.length == 0) {
                    let index = this.tableData.indexOf(row);
                    this.tableData.splice(index,1)
                } else {
                    this.$message({
                        type: 'warning',
                        message: this.buttonTextConfig.notDeleteTip
                    });

                }
            } else {
                let index = this.tableData.indexOf(row);
                this.tableData.splice(index,1)
            }
        },
        handleSelectionChange(val) {
            this.selectRow = []
            for (let i = 0; i < val.length; i++) {
                const e = val[i];
                this.selectRow.push(e)
            }
        },
        close() {
            this.chooseDialogVisible = false
        },
        choose(tableData) {
            this.tableData =JSON.parse(JSON.stringify(tableData))
        },
        check() {
            if (this.tableData.length == 0) {
                this.$message({
                    type: 'warning',
                    message: '请选择赛卷'
                });
            } else {
                let paperIds = []
                this.tableData.forEach(item=>{paperIds.push(item.id)})
                this.$store.state.arrangeExam.confirmPreview = true
                this.$store.state.arrangeExam.confirmPaperData.examPaperIdList = paperIds
                this.$store.state.arrangeExam.tableData = this.tableData
                this.$store.state.arrangeExam.confirmPaperData.examIdList = [this.examId]
                this.$store.state.arrangeExam.examId = this.examId
            }


        },
        checkChange() {
            let flag = true;
            if (this.tableData.length != this.oldTableData.length) {
                flag = false;
            } else {
                for (let i = 0; i < this.tableData.length; i++) {
                    let data = this.oldTableData.filter((item)=> item.id == this.tableData[i].id)
                    if (data.length == 0) {
                        flag = false;
                        break
                    }
                }
            }
            return flag
        },

    },
    created() {
        getExamPaperLimitNum().then(res => {
            if (res.status === 200) {
                this.limitNum = res.data
            }
        })
        if (this.examId) {
            if (this.$store.state.arrangeExam.isBack) {
                this.tableData = this.$store.state.arrangeExam.tableData
                this.$store.state.arrangeExam.isBack = false
                getExamPapers(this.examId).then(res => {
                    if (res.status === 200) {
                        this.oldTableData = JSON.parse(JSON.stringify(res.data))
                    }
                })
            } else {
                getExamPapers(this.examId).then(res => {
                    if (res.status === 200) {
                        this.tableData = res.data
                        this.oldTableData = JSON.parse(JSON.stringify(res.data))
                    }
                })
            }

        }
    },
}
</script>

<style scoped>
</style>
